import React, { useState } from "react";
import {
    DKLabel,
    DKButton,
    DKIcons
} from "deskera-ui-library";
import CompanyDetails from "../../CompanySetting/CompanyDetails";
import { ONBOARDING_STEP, STEP_NAME, USOnboardingWizardSteps } from "./SetupDetails";
import USTaxDetailsNew from "../../compliance/us/USTaxDetailsNew";
import AddBankAccountUS from "../../compliance/us/AddBankAccountUS";
import FillingAuthorization from "../../compliance/us/FillingAuthorization";
import TenantManager from "../../../managers/TenantManager";

function OnboardingWizard(props) {

    const [width] = useState("65vw");
    const [height] = useState("80vh");
    const [selectedStep, setSelectedStep] = useState(props.selectedStep);

    const renderHeader = () => {
        return (
            <div className="row justify-content-between p-h-xxl p-v-m bg-gray2">
                <DKLabel text={selectedStep.name} className="fs-l fw-m" />
                <DKButton icon={DKIcons.ic_close} onClick={props.onClose} />
            </div>
        )
    }

    const onSaveAndNext = () => {
        const incompleteStages = [];
        const profileStages = TenantManager.getProfileData();
        props.tenantProfileStages.forEach((stage) => {
            if (stage != selectedStep.id && !profileStages[stage] && USOnboardingWizardSteps.includes(stage)) {
                incompleteStages.push({
                    id: stage,
                    name: STEP_NAME[stage]
                });
            }
        });

        if (incompleteStages.length > 0) {
            setSelectedStep(incompleteStages[0]);
        } else {
            props.onClose();
        }
    }

    const renderStep = (step) => {
        switch (step.id) {
            case ONBOARDING_STEP.companyDetails:
                return (
                    <CompanyDetails
                        {...props}
                        renderAsStep={true}
                        onClose={() => props.onClose()}
                        onSaveAndNext={() => onSaveAndNext()}
                    />
                );
            case ONBOARDING_STEP.taxDetails:
                return (
                    <USTaxDetailsNew
                        {...props}
                        renderAsStep={true}
                        onClose={() => props.onClose()}
                        onSaveAndNext={() => onSaveAndNext()}
                    />
                );
            case ONBOARDING_STEP.bankDetails:
                return (
                    <AddBankAccountUS
                        {...props}
                        renderAsStep={true}
                        onClose={() => props.onClose()}
                        onSaveAndNext={() => onSaveAndNext()}
                    />
                );
            case ONBOARDING_STEP.filingAuthorization:
                return (
                    <FillingAuthorization
                        {...props}
                        renderAsStep={true}
                        onClose={() => props.onClose()}
                        onSaveAndNext={() => onSaveAndNext()}
                    />
                );
            default:
                break;
        }
    }

    return (
        <div className="transparent-background">
            <div className="popup-window" style={{ padding: 0, minWidth: width, maxWidth: width, minHeight: height, maxHeight: height, overflow: "inherit" }}>
                {/* {renderHeader()} */}
                <div className="parent-width custom-scroll" style={{ minHeight: `calc(${height} - 0px)`, maxHeight: `calc(${height} - 0px)`, overflow: "auto" }}>
                    {renderStep(selectedStep)}
                </div>
            </div>
        </div>
    );
}

export default OnboardingWizard;
